import {
  ChevronDownIcon,
  Dropdown,
  FlexBox,
  JoonUIColor,
  SPACING,
  Typography,
} from "@joonapp/web-shared"
import { useNavigate } from "react-router-dom"

import useCoachingProfile from "../../hooks/useCoachingProfile"
import { useUserQuery } from "../../networking/user/queries"
import { useAuth } from "../../util/auth"
import ProfileImage from "../profileImage/ProfileImage"

const ProfileDropdown = () => {
  const { signout } = useAuth()
  const navigate = useNavigate()
  const { data: user } = useUserQuery()

  const coachingProfile = useCoachingProfile()

  const profileImg = coachingProfile?.profile_image_url || ""

  return (
    <Dropdown
      trigger={
        <FlexBox
          direction="row"
          align="center"
          gap={SPACING.space2}
          style={{ transform: `translateY(${SPACING.space05})` }}
        >
          <ProfileImage
            profileUrl={profileImg}
            userName={user?.name || ""}
            size="small"
            color="purple"
          />
          <Typography variant="bodySmall" color={JoonUIColor.text.secondary}>
            {user?.name || ""}
          </Typography>
          <ChevronDownIcon size={16} color={JoonUIColor.text.disabled} />
        </FlexBox>
      }
      items={[
        {
          label: "Settings",
          value: "settings",
          onClick: () => navigate("/settings"),
        },
        { label: "Logout", value: "logout", onClick: () => signout() },
      ]}
      position="bottom"
    />
  )
}

export default ProfileDropdown
